import { findEanByClient, findEanByClientColorProduct } from '../../_services/ean.service';

export const findEanByClientColorProductEvent = async (client, color, product) => {
    let res = await findEanByClientColorProduct(client, color, product);
    if(!res.ok){
        throw new Error(res.error);
    }
    
    return res;
}

export const findEanByClientEvent = async (client) => {
    let res = await findEanByClient(client);
    if(!res.ok){
        throw new Error(res.error);
    }
    
    return res;
}